import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const queryKeys = createQueryKeyStore({
    clients: {
        all: null,
    },
    surveys: {
        byId: (surveyId: string) => [surveyId],
    }
});
